import { render, staticRenderFns } from "./original.vue?vue&type=template&id=9c65c1f4&scoped=true&"
import script from "./original.vue?vue&type=script&lang=js&"
export * from "./original.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c65c1f4",
  null
  
)

export default component.exports